import { Card, Tabs, Table, Row, Col, Tag, Form, Input, Button, Dropdown, Menu, Upload, Steps, Modal, Skeleton, Select, Image, Space, List, Divider, InputNumber, DatePicker, Carousel, Checkbox } from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
// import Clock from 'react-live-clock';
import { formatCurrency } from '../common/Format'
import {
    MenuOutlined, SettingOutlined, DeleteOutlined, FormOutlined, FileTextOutlined, PlusOutlined, UserOutlined, EyeOutlined, CheckOutlined, CloseOutlined
} from "@ant-design/icons";
import swal from "sweetalert";

import 'moment/locale/vi';
import { Editor } from '@tinymce/tinymce-react';
import ButtonGroup from "antd/lib/button/button-group";
import moment from "moment";
import axiosClient from "../../api/axios";
import LinkUpload from "../../api/LinkUpload";
import limitString from "../common/LimitString/litmitstring";
import { changeUpload, updateFileListFromUrls, uploadImage, beforeUpload, getFilePreview } from '../common/Upload/upload.js'
import * as XLSX from 'xlsx';


const { Step } = Steps;
const { TabPane } = Tabs;
const { Option } = Select;
const Content = () => {
    const editorRef = useRef(null);  // Khai báo editorInstanceRef để giữ tham chiếu editor
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState(0);
    const [value, setValue] = useState('');
    const [text, setText] = useState('');
    const database = localStorage.getItem('DatabaseName');
    const token = localStorage.getItem('token');
    const [articles, setArticles] = useState({})
    const IDAccount = localStorage.getItem('ID');
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    const user = {
        "ID": localStorage.getItem('ID'),
        "Role": localStorage.getItem('Role'),
        "UserName": localStorage.getItem('UserName'),
        "FullName": localStorage.getItem('FullName'),
        "Password": localStorage.getItem('Password'),
        "Phone": localStorage.getItem('Phone'),
        "Email": localStorage.getItem('Email'),
        "Image": localStorage.getItem('Image'),
        "Active": true,
        "DatabaseName": localStorage.getItem('DatabaseName'),
        "SecurityCode": localStorage.getItem('SecurityCode'),
        "ExpirationDate": localStorage.getItem('ExpirationDate')
    }
    const [dataAccount, setDataAccount] = useState([])
    const [formCategories] = Form.useForm();
    const [formTags] = Form.useForm();
    const [formArticleTags] = Form.useForm();
    const [formFilterCategories] = Form.useForm()
    const [formArticles] = Form.useForm();
    const [formFilterArticles] = Form.useForm()
    const [step, setStep] = useState(0)

    // Quản lý thông tin Danh mục
    const [dataCategories, setDataCategories] = useState([]);
    const [openModalCategories, setOpenModalCategories] = useState(false);

    const [statusCategories, setStatusCategories] = useState(false);
    // Quản lý thông tin tag 
    const [dataTags, setDataTags] = useState([]);
    const [openModalTags, setOpenModalTags] = useState(false);

    const [statusTags, setStatusTags] = useState(false);
    // Quản lý thông tin tag bài viết
    const [dataArticleTags, setDataArticleTags] = useState([]);
    const [openModalArticleTags, setOpenModalArticleTags] = useState(false);
    const [statusArticleTags, setStatusArticleTags] = useState(false);
    const [selectedTags, setSelectedTags] = useState([]);
    // Quản lý bài viết
    const [dataArticles, setDataArticles] = useState([]);
    const [openModalArticles, setOpenModalArticles] = useState(false);

    const [statusArticles, setStatusArticles] = useState(false);
    const [openModalViewArticles, setOpenModalViewArticles] = useState(false)

    // upload image
    const [currentIDArticles, setCurrentIDArticles] = useState(0)
    const [fileListArticles, setFileListArticles] = useState([]);


    // const uploadImage = async options => {
    //     const { onSuccess, onError, file, onProgress } = options;
    //     const fmData = new FormData();
    //     const config = {
    //         headers: {
    //             "content-type": "multipart/form-data",
    //             Accept: "application/json",
    //             Authorization: `Bearer ${token}`,
    //         },
    //         onUploadProgress: event => {
    //             const percent = Math.floor((event.loaded / event.total) * 100);
    //             setProgress(percent);
    //             if (percent === 100) {
    //                 setTimeout(() => setProgress(0), 1000);
    //             }

    //         }
    //     };

    //     const filenew = new File([file], file.name, {
    //         type: 'image/png'
    //     });
    //     fmData.append("image", filenew);
    //     try {

    //         const res = await axiosClient.post(
    //             `/uploadfile?subDirectory=${database}`,
    //             fmData,
    //             config
    //         );
    //         onSuccess("Ok");
    //         console.log("server res: ", res);
    //         if (res.status === 200) {
    //             setProgress(0)
    //         }

    //     } catch (err) {
    //         console.log("Eroor: ", err);
    //         const error = new Error("Some error");
    //         onError({ err });
    //     }

    // };



    const showModalCategories = (record) => {
        //const IDTemp = 0;
        formCategories.resetFields();
        if (typeof record === 'object') {
            setLoading(false)
            setStatusCategories(true)
            formCategories.setFieldsValue(
                record
            );
            setOpenModalCategories(true)
        }
        else {
            setLoading(false)
            setStatusCategories(false)
            formCategories.setFieldsValue({
                "ID": 1,
                "Name": "",
                "Slug": "",
                "Description": ""
            })
            setOpenModalCategories(true)
        }


    }
    const showModalTags = (record) => {
        //const IDTemp = 0;
        formTags.resetFields();
        if (typeof record === 'object') {
            setLoading(false)
            setStatusTags(true)
            formTags.setFieldsValue(
                record
            );
            setOpenModalTags(true)
        }
        else {
            setLoading(false)
            setStatusTags(false)
            formTags.setFieldsValue({
                "ID": 1,
                "Name": "",
                "Slug": ""
            })
            setOpenModalTags(true)
        }

    }
    const showModalArticleTags = (record) => {

        formArticleTags.resetFields();
        if (typeof record === 'object') {
            setLoading(false)
            setStatusArticleTags(true)
            formArticleTags.setFieldsValue(
                record
            );
            setOpenModalArticleTags(true)
        }
        else {
            setLoading(false)
            setStatusArticleTags(false)
            formArticleTags.setFieldsValue({
                "ID": 1,
                "IDTag": [],
                "IDArticle": ""
            })
            setOpenModalArticleTags(true)
        }

    }
    const [dataTagsDetail, setDataTagsDetail] = useState([])


    const onFinishCategories = (values) => {

        setLoading(true)
        if (statusCategories === false) {
            axiosClient.post('/Categories/AddCategories', values, {
                headers: header
            }).then(res => {
                setLoading(false)
                swal('Thành công!', {
                    icon: 'success'
                })
                formCategories.resetFields();
                LoadDataCategories();
                setOpenModalCategories(false)
            })
        }
        else {

            axiosClient.post('/Categories/UpdateCategories', values, {
                headers: header
            }).then(res => {
                if (res.status === 200) {
                    setLoading(false)
                    swal('Thành công!', {
                        icon: 'success'
                    })
                    formCategories.resetFields();
                    LoadDataCategories();
                    setOpenModalCategories(false)
                }
            })
        }

    }
    const onFinishTags = (values) => {

        setLoading(true)
        if (statusTags === false) {
            axiosClient.post('/Tags/AddTags', values, {
                headers: header
            }).then(res => {
                setLoading(false)
                swal('Thành công!', {
                    icon: 'success'
                })
                formTags.resetFields();
                LoadDataTags();
                setOpenModalTags(false)
            })
        }
        else {

            axiosClient.post('/Tags/UpdateTags', values, {
                headers: header
            }).then(res => {
                if (res.status === 200) {
                    setLoading(false)
                    swal('Thành công!', {
                        icon: 'success'
                    })
                    formTags.resetFields();
                    LoadDataTags();
                    setOpenModalTags(false)
                }
            })
        }

    }






    const LoadDataCategories = () => {
        axiosClient.post('/Categories/GetCategoriesAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataCategories(res.data);
            }
        })
    }
    const LoadDataTags = () => {
        axiosClient.post('/Tags/GetTagsAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataTags(res.data);
            }
        })
    }
    const [dataFilterArticle, setDataFilterArticle] = useState({
        "Title": "",
        "IDCategory": 0,
        "Status": 0,
        "FromDate_PublishDate": "",
        "ToDate_PublishDate": ""
    })
    const LoadDataArticles = (values) => {
        axiosClient.post('/Articles/FilterArticles', values, {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataArticles(
                    res.data.sort((a, b) => new Date(b.PublishDate) - new Date(a.PublishDate))
                );
            }
        })
    }
    const [dataPermission, setDataPermission] = useState([]);
    const LoadDataPermission = () => {
        axiosClient.post('/Permissions/GetApiPermissionAll', '', { headers: header }).then(resPermiss => {
            setDataPermission(resPermiss.data);
        })
    }

    const renderCategories = () => {
        return (
            <Form
                id="form-Categories"
                form={formCategories}
                onFinish={onFinishCategories}
                colon={false}
                name="basic"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name='ID'>
                    <Input />
                </Form.Item>

                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Nhập tên Danh mục',
                    },
                ]} name='Name' label='Tên Danh mục'>
                    <Input />
                </Form.Item>

                <Form.Item hidden rules={[
                    {
                        required: false,
                        message: 'Nhập tên Danh mục',
                    },
                ]} label='Slug' name={'Slug'}>
                    <Input />
                </Form.Item>
                <Form.Item name='Description' label='Mô tả'>
                    <Input.TextArea />
                </Form.Item>


            </Form >
        )
    }
    const renderTags = () => {
        return (
            <Form
                id="form-Tags"
                form={formTags}
                onFinish={onFinishTags}
                colon={false}
                name="basic"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name='ID'>
                    <Input />
                </Form.Item>

                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Nhập tên thẻ',
                    },
                ]} name='Name' label='Tên thẻ'>
                    <Input />
                </Form.Item>

                <Form.Item hidden label='Slug' name={'Slug'}>
                    <Input />
                </Form.Item>

            </Form >
        )
    }
    const onFinishArticleTags = (values) => {

        if (values.IDTag.length === 0) {
            swal('Vui lòng chọn các tag cho bài viết!', {
                icon: 'warning',
                timer: 3000
            })
        }
        else {
            setLoading(true)
            if (statusArticleTags === false) {
                values.IDTag.map(r => (
                    axiosClient.post('/ArticleTags/AddArticleTags', {
                        "ID": values.ID,
                        "IDTag": r,
                        "IDArticle": values.IDArticle
                    }, { headers: header })
                ))
                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                })
                LoadDataArticles(dataFilterArticle)
                LoadDataArticleTags()
                setOpenModalArticleTags(false)
                setLoading(false)
            }
            else {

                axiosClient.post('/ArticleTags/UpdateArticleTags', values, { headers: header })

                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                })
                LoadDataArticles(dataFilterArticle)
                LoadDataArticleTags()
                setOpenModalArticleTags(false)
                setLoading(false)
            }

        }
    }

    const renderArticleTags = () => {
        return (
            <Form
                id="form-ArticleTags"
                form={formArticleTags}
                onFinish={onFinishArticleTags}
                colon={false}
                name="basic"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name='ID'>
                    <Input />
                </Form.Item>

                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Chọn tên bài viết',
                    },
                ]} name='IDArticle' label='Bài viết'>
                    <Select>
                        {dataArticles?.map(r => (
                            <Option value={r.ID}>{r.Title}</Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Chọn tag bài viết',
                    },
                ]} name='IDTag' label='Tag bài viết'>
                    <Select
                        mode={statusArticleTags === false ? "multiple" : ''}
                        style={{ width: '100%' }}
                        placeholder="Chọn tag"
                        allowClear
                        filterOption={(input, option) =>
                            option?.children?.toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {dataTags.map((tag) => (
                            <Option key={tag.ID} value={tag.ID}>
                                {tag.Name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

            </Form >
        )
    }
    const onDeleteCategories = (id) => {
        if (id !== 0) {
            swal({
                title: "Bạn có muốn xóa Danh mục này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/Categories/DeleteCategories/${id}`, id, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataCategories()
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const onDeleteTags = (id) => {
        if (id !== 0) {
            swal({
                title: "Bạn có muốn xóa Danh mục này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/Categories/DeleteCategories/${id}`, id, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataCategories()
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const onDeleteArticleTags = (id) => {
        if (id !== 0) {
            swal({
                title: "Bạn có muốn xóa tag bài viết này này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/ArticleTags/DeleteArticleTags/${id}`, id, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataArticleTags()
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const changePositionCategory = (record, value) => {
        axiosClient.post('/Categories/UpdateCategories', {
            ...record,
            OrderCategory: value
        }, { headers: header }).then(res => {
            if (res.status === 200) {
                LoadDataCategories()
            }
        })
    }
    const columnCategories = [
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    ID
                </div>
            ),
            dataIndex: 'Name',
            width: 70,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.ID}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Danh mục
                </div>
            ),
            dataIndex: 'Name',
            width: 300,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left" }}>
                        {record.Name}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Slug
                </div>
            ),
            dataIndex: 'Phone',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.Slug}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Thứ tự
                </div>
            ),
            dataIndex: 'Phone',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <InputNumber onChange={(e) => changePositionCategory(record, e)} min={0} defaultValue={record.OrderCategory} />
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Mô tả
                </div>
            ),
            dataIndex: 'Zalo',
            width: 250,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left" }}>
                        {record.Description}
                    </div>
                );
            },
        },

        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <ButtonGroup>
                            <Button disabled={dataPermission.includes('UpdateCategories') ? false : true} icon={<FormOutlined style={{ color: "#33CCFF" }} />} onClick={(e) => showModalCategories(record)}  ></Button>
                            &ensp;
                            <Button
                                disabled={dataPermission.includes('DeleteCategories') ? false : true}
                                onClick={(e) => {
                                    onDeleteCategories(record.ID, e);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button>
                        </ButtonGroup>
                    </div>
                );
            },
        },
    ]
    const columnTags = [
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    ID
                </div>
            ),
            dataIndex: 'Name',
            width: 80,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.ID}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Tên thẻ
                </div>
            ),
            dataIndex: 'Name',
            width: 300,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left" }}>
                        {record.Name}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Slug
                </div>
            ),
            dataIndex: 'Phone',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.Slug}
                    </div>
                );
            },
        },


        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <ButtonGroup>
                            <Button disabled={dataPermission.includes('UpdateTags') ? false : true} icon={<FormOutlined style={{ color: "#33CCFF" }} />} onClick={(e) => showModalTags(record)}  ></Button>
                            &ensp;
                            <Button
                                disabled={dataPermission.includes('DeleteTags') ? false : true}
                                onClick={(e) => {
                                    onDeleteTags(record.ID, e);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button>
                        </ButtonGroup>
                    </div>
                );
            },
        },
    ]
    function filterArticlesByTags(articles, tags) {
        return articles.filter(article =>
            tags.some(tag => tag.IDArticle === article.ID)
        );
    }
    const columnArticleTags = [
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Bìa viết
                </div>
            ),
            dataIndex: 'Name',
            width: 300,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left" }}>
                        {dataArticles.find(i => i.ID === record.IDArticle).Title}
                    </div>
                );
            },
        },

        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Tag
                </div>
            ),
            dataIndex: 'Phone',
            width: 150,
            render: (text, record) => {

                return (
                    <div style={{ textAlign: "center" }}>

                        <Tag color="gold">
                            {dataTags.find(i => i.ID === record.IDTag).Name}
                        </Tag>

                    </div>
                );
            },
        },

        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <ButtonGroup>
                            <Button disabled={dataPermission.includes('UpdateArticleTags') ? false : true} icon={<FormOutlined style={{ color: "#33CCFF" }} />} onClick={(e) => showModalArticleTags(record)}  ></Button>
                            &ensp;
                            <Button
                                disabled={dataPermission.includes('DeleteArticleTags') ? false : true}
                                onClick={(e) => {
                                    onDeleteArticleTags(record.ID, e);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button>
                        </ButtonGroup>
                    </div>
                );
            },
        },
    ]
    const changeCategory = (value, child) => {
        setCurrentIDArticles(Number(child.key))
        formArticles.setFieldsValue({
            IDCategory: Number(child.key)
        })
    }
    const normalizeTagName = (s) => String(s || '').replace(/\s+/g, ' ').trim();

    // options cho Select (mode=tags)
    const tagOptions = useMemo(() => {
        const names = (dataTags || [])
            .map(t => normalizeTagName(t.Name))
            .filter(Boolean);
        const unique = [...new Set(names)];
        return unique.map(n => ({ label: n, value: n }));
    }, [dataTags]);
    const showModalArticles = (record) => {
        setFileListArticles([]);
        setValue('');
        setText('');
        formArticles.resetFields();

        if (typeof record === 'object') {
            setLoading(false);
            setStatusArticles(true);
            setCurrentIDArticles(record.IDCategory);
            updateFileListFromUrls(setFileListArticles, record.ImageUrl);

            // Lấy các IDTag của bài
            const listTagIDs = (dataArticleTags || [])
                .filter(i => Number(i.IDArticle) === Number(record.ID))
                .map(r => Number(r.IDTag));

            // Map ID -> Name (chuẩn hoá)
            const cleanTags = (dataTags || []).map(t => ({
                ID: Number(t.ID),
                Name: normalizeTagName(t.Name)
            }));

            const tagNames = listTagIDs
                .map(id => cleanTags.find(t => t.ID === id)?.Name || null)
                .filter(Boolean);

            const uniqueTagNames = [...new Set(tagNames)]; // mảng tên cho Select

            // debug nếu thiếu định nghĩa
            const missingIDs = listTagIDs.filter(id => !cleanTags.some(t => t.ID === id));
            if (missingIDs.length) console.warn('Thiếu Tag ID trong dataTags:', missingIDs);

            const categoryName = (dataCategories || [])
                .find(i => Number(i.ID) === Number(record.IDCategory))?.Name;

            formArticles.setFieldsValue({
                ID: record.ID,
                Title: record.Title,
                Slug: record.Slug,
                ArticleContent: record.ArticleContent,
                Sumary: record.Sumary,
                ImageUrl: record.ImageUrl,
                IDAuthor: record.IDAuthor,
                IDCategory: record.IDCategory,
                PublishDate: moment(record.PublishDate),
                Status: record.Status,
                ArticleView: record.ArticleView,
                Category: categoryName,
                Tag: uniqueTagNames, // <— quan trọng: Select multiple cần mảng tên
            });

            setValue(record.ArticleContent);
            setOpenModalArticles(true);
            setStep(0);
        } else {
            setStep(0);
            setLoading(false);
            setStatusArticles(false);
            formArticles.setFieldsValue({
                ID: 1, Title: "", Slug: "", ArticleContent: "", Sumary: "",
                ImageUrl: "", IDAuthor: Number(IDAccount), IDCategory: "",
                PublishDate: moment(), Status: 1, ArticleView: 0, Tag: []
            });
            setOpenModalArticles(true);
        }
    };

    const onFinishArticles = async (values) => {
        setLoading(true);

        const isUpdate = statusArticles === true;
        const isFinalStep = step === 1;
        if (!isFinalStep) {
            setStep(step + 1);
            setLoading(false);
            return;
        }

        // helpers
        const normName = (s) => String(s || '').replace(/\s+/g, ' ').trim();
        const toTagNames = (raw) => {
            if (raw === undefined || raw === null) return [];
            if (Array.isArray(raw)) return [...new Set(raw.map(v => normName(v)).filter(Boolean))];
            return [...new Set(String(raw).split(',').map(normName).filter(Boolean))];
        };

        // payload bài viết
        const payload = {
            ID: isUpdate ? values.ID : 1,
            Title: values.Title,
            Slug: values.Slug,
            ArticleContent: text,
            Sumary: values.Sumary,
            ImageUrl: values.ImageUrl,
            IDAuthor: values.IDAuthor,
            IDCategory: values.IDCategory,
            PublishDate: values.PublishDate,
            Status: values.Status,
            ArticleView: values.ArticleView,
        };

        const url = isUpdate ? '/Articles/UpdateArticles' : '/Articles/AddArticles';

        try {
            // 1) Lưu bài
            const res = await axiosClient.post(url, payload, { headers: header });
            const articleID = isUpdate ? values.ID : res?.data?.ID;

            if (!articleID) {
                console.warn('Không lấy được articleID -> skip tag');
                LoadDataArticles(dataFilterArticle);
                swal('Thành công!', { icon: 'success', timer: 5000 });
                return;
            }

            // 2) Chuẩn hoá danh sách tên tag user chọn
            const inputNames = toTagNames(values.Tag); // ["tag A","tag B",...]
            // 3) Bảng tag hiện có để map Name -> ID
            const toCleanTags = () => (dataTags || []).map(t => ({
                ID: Number(t.ID),
                Name: normName(t.Name),
                Slug: t.Slug || ''
            }));
            let cleanTags = toCleanTags();

            // 4) Đảm bảo có ID cho mọi tên (tạo tag mới nếu chưa có)
            const desiredTagIDs = [];
            for (const name of inputNames) {
                const found = cleanTags.find(t => t.Name.toLowerCase() === name.toLowerCase());
                if (found) {
                    desiredTagIDs.push(found.ID);
                } else {
                    try {
                        // tạo tag mới (ID mặc định 1 theo spec của bạn)
                        const addTagRes = await axiosClient.post('/Tags/AddTag', { ID: 1, Name: name, Slug: '' }, { headers: header });
                        // sau khi tạo, cố gắng lấy ID từ response trước
                        const newIdFromRes = addTagRes?.data?.ID ?? addTagRes?.data?.Data?.ID ?? addTagRes?.data?.Tag?.ID;
                        if (newIdFromRes) {
                            desiredTagIDs.push(Number(newIdFromRes));
                        } else {
                            // fallback: reload dataTags rồi tìm lại
                            if (typeof LoadDataTags === 'function') await LoadDataTags();
                            cleanTags = toCleanTags();
                            const justMade = cleanTags.find(t => t.Name.toLowerCase() === name.toLowerCase());
                            if (justMade) desiredTagIDs.push(justMade.ID);
                        }
                    } catch (e) {
                        console.error('Tạo tag mới thất bại:', name, e);
                    }
                }
            }

            // unique + hợp lệ
            const desiredSet = new Set(desiredTagIDs.filter(id => !isNaN(id)));

            // 5) Lấy các quan hệ hiện có của bài
            const existingRels = (dataArticleTags || [])
                .filter(x => Number(x.IDArticle) === Number(articleID)); // [{ID, IDTag, IDArticle}]
            const existingSet = new Set(existingRels.map(r => Number(r.IDTag)));

            // 6) XÓA các quan hệ thừa (user đã bỏ chọn)
            const relsToRemove = existingRels.filter(rel => !desiredSet.has(Number(rel.IDTag)));
            if (relsToRemove.length > 0) {
                await Promise.all(
                    relsToRemove.map(rel =>
                        // nếu API là DELETE thì đổi sang axiosClient.delete
                        axiosClient.post(`/ArticleTags/DeleteArticleTags/${rel.ID}`, {}, { headers: header })
                    )
                );
            }

            // 7) THÊM các quan hệ còn thiếu (user vừa thêm)
            const toAdd = [...desiredSet].filter(idTag => !existingSet.has(idTag));
            if (toAdd.length > 0) {
                await Promise.all(
                    toAdd.map(idTag =>
                        axiosClient.post('/ArticleTags/AddArticleTags', {
                            ID: 1,            // theo spec “thêm mới mặc định bằng 1”
                            IDTag: idTag,
                            IDArticle: articleID
                        }, { headers: header })
                    )
                );
            }

            // 8) Refresh dữ liệu UI
            if (typeof LoadDataTags === 'function') await LoadDataTags();
            if (typeof LoadDataArticleTags === 'function') await LoadDataArticleTags();
            LoadDataArticles(dataFilterArticle);

            swal('Thành công!', { icon: 'success', timer: 5000 });
        } catch (err) {
            console.error("Lỗi khi lưu bài viết:", err);
            LoadDataArticles(dataFilterArticle);
        } finally {
            setLoading(false);
            setStep(0);
            setOpenModalArticles(false);
        }
    };



    const renderArticles = () => {
        return (

            <Form
                id="form-Articles"
                form={formArticles}
                onFinish={onFinishArticles}
                colon={false}
                name="basic"
                labelCol={{
                    span: 24,
                    style: { fontWeight: 'bold' },
                }}
                wrapperCol={{
                    span: 24,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name='ID'>
                    <Input />
                </Form.Item>
                <Form.Item hidden name='IDCategory'>
                    <Input />
                </Form.Item>
                <Form.Item hidden name='ArticleContent'>
                    <Input />
                </Form.Item>
                <Form.Item hidden name='IDAuthor'>
                    <Input />
                </Form.Item>
                <Form.Item hidden name='ArticleView'>
                    <Input />
                </Form.Item>
                <Form.Item hidden={step === 1 ? true : false} rules={[
                    {
                        required: step === 1 ? false : true,
                        message: 'Nhập tên tiêu đề',
                    },
                ]} name='Title' label='Tiêu đề'>
                    <Input />
                </Form.Item>
                <Form.Item hidden label='Slug' name={'Slug'}>
                    <Input />
                </Form.Item>
                <Form.Item hidden={step === 1 ? true : false} name='Sumary' label='Bản tóm tắt'>
                    <Input.TextArea style={{ minHeight: 100 }} />
                </Form.Item>
                <Form.Item hidden={statusArticles === true && step === 0 ? false : true} label='Ngày viết' name='PublishDate'>
                    <DatePicker format={'DD-MM-YYYY'} style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item hidden={step === 1 ? true : false} rules={[
                    {
                        required: step === 1 ? false : true,
                        message: 'Chọn trạng thái',
                    },
                ]} name='Status' label='Trạng thái'>
                    <Select>
                        <Option value={1}>Hiển thị</Option>
                        <Option value={2}>Hủy</Option>
                    </Select>
                </Form.Item>
                <Form.Item hidden={step === 1 ? true : false} rules={[
                    {
                        required: step === 1 ? false : true,
                        message: 'Chọn danh mục',
                    },
                ]} name='Category' label='Danh mục'>
                    <Select onChange={changeCategory} showSearch>
                        {dataCategories.map(r => (
                            <Option key={r.ID} value={r.Name}>
                                {r.Name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    hidden={step === 1 ? true : false}
                    rules={[{ required: step === 1 ? false : true, message: 'Nhập Tag' }]}
                    name='Tag'
                    label='Tag'
                >
                    <Select
                        mode="tags"                  // cho phép gõ để tạo mới
                        allowClear
                        showSearch
                        tokenSeparators={[',']}      // gõ dấu phẩy để tách nhanh
                        placeholder="Chọn hoặc gõ để thêm tag..."
                        options={tagOptions}         // gợi ý từ hệ thống
                        style={{ width: '100%' }}
                        filterOption={(input, option) =>
                            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                        onChange={(vals) => {
                            // chuẩn hoá & bỏ trùng mỗi lần thay đổi
                            const next = [...new Set((vals || []).map(normalizeTagName).filter(Boolean))];
                            formArticles.setFieldsValue({ Tag: next });
                        }}
                    />
                </Form.Item>
                <Form.Item hidden={currentIDArticles !== 0 && step === 0 ? false : true} name='ImageUrl' label='Ảnh bìa'>
                    <Upload
                        multiple
                        listType="picture-card"
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        maxCount={1}
                        fileList={fileListArticles}
                        onPreview={(file) => window.open(file.url)}
                        onChange={(info) => changeUpload(formArticles, 'ImageUrl', info, setFileListArticles)}
                        onRemove={(file) => {
                            // Xử lý khi file bị xóa
                            // Ví dụ: Cập nhật lại fileLists sau khi file bị xóa
                            const updatedFileList = fileListArticles.filter(f => f.uid !== file.uid);  // Loại bỏ file bị xóa
                            setFileListArticles(updatedFileList);  // Cập nhật lại danh sách file
                        }}
                    >
                        <Button
                            style={{
                                width: "100%",
                                height: 100,
                                border: "2px dashed #40a9ff",
                                backgroundColor: "#f0faff",
                                borderRadius: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 5,
                                color: "#1890ff",
                                fontWeight: 500,
                            }}
                        >
                            <PlusOutlined style={{ fontSize: 24 }} />
                            <span>Upload Ảnh</span>
                        </Button>
                    </Upload>
                </Form.Item>
                <div hidden={step !== 1}>
                    <Editor
                        value={value}
                        onInit={(evt, editor) => {
                            editorRef.current = editor;
                            setText(editor.getContent({ format: "html" }));
                            formArticles.setFieldsValue({
                                ArticleContent: editor.getContent({ format: "html" }),
                            });
                        }}
                        ref={editorRef}
                        onEditorChange={(newValue, editor) => {
                            setValue(newValue);
                            setText(editor.getContent({ format: "html" }));
                            formArticles.setFieldsValue({
                                ArticleContent: editor.getContent({ format: "html" }),
                            });
                        }}
                        apiKey="s71p6k6n6bk69n0axoev45jqyaq2h4zb2olaruzd9j5wdtnr"
                        init={{
                            height: 500,
                            menubar: true,
                            plugins: [
                                "advlist", "anchor", "autolink", "charmap", "code",
                                "help", "image", "insertdatetime", "link", "lists", "media",
                                "preview", "searchreplace", "table", "visualblocks",
                            ],
                            toolbar:
                                "undo redo | fontselect | casechange blocks | bold italic backcolor | " +
                                "alignleft aligncenter alignright alignjustify | " +
                                "bullist numlist checklist outdent indent | removeformat | " +
                                "a11ycheck code table help | link | image | insertTemplateList", // Đảm bảo có "image"
                            content_style:
                                "body { font-family:Helvetica,Arial,sans-serif,Times New Roman; font-size:14px }",
                            link_context_toolbar: true,
                            link_title: true,
                            default_link_target: "_blank",
                            encoding: "xml",
                            entity_encoding: "raw",
                            entities: "160,nbsp",
                            automatic_uploads: true,
                            file_picker_types: "image file", // Đảm bảo bạn đã thêm hỗ trợ cho file hình ảnh
                            images_upload_handler: async (blobInfo, success, failure, progress) => {
                                const formData = new FormData();
                                formData.append('file', blobInfo.blob());
                                const config = {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                        'Authorization': `Bearer ${token}`,
                                    },
                                };
                                try {
                                    const response = await axiosClient.post(`/uploadfile?subDirectory=${database}`, formData, config);
                                    const filePath = String(response.data?.FilePath);  // Chắc chắn chuyển filePath thành chuỗi
                                    if (!filePath) {
                                        console.error('No file path returned from server');
                                        failure('No file path returned from server');
                                        return;
                                    }
                                    return LinkUpload(filePath)
                                } catch (err) {
                                    console.error('Upload failed:', err);
                                    if (typeof failure === 'function') {
                                        failure(err.message || "Upload file failed");
                                    } else {
                                        console.error("Failure callback is not a function or not provided");
                                    }
                                }
                            },

                            file_picker_callback: function (callback, value, meta) {
                                if (meta.filetype === "file") {
                                    const input = document.createElement("input");
                                    input.setAttribute("type", "file");
                                    input.setAttribute("accept", ".pdf,.docx,.xlsx"); // Hỗ trợ các loại file đính kèm khác
                                    input.setAttribute('multiple', 'true');  // Cho phép chọn nhiều file
                                    input.onchange = function () {
                                        const files = this.files;  // Lấy danh sách các file đã chọn

                                        // Tạo một FormData và gửi mỗi file lên server riêng biệt
                                        Array.from(files).forEach(file => {
                                            const formData = new FormData();
                                            formData.append('file', file);  // Chỉ gửi một file mỗi lần

                                            const config = {
                                                headers: {
                                                    'Authorization': `Bearer ${token}`,  // Thêm token nếu cần
                                                    'Content-Type': 'multipart/form-data', // Đảm bảo đúng Content-Type
                                                }
                                            };

                                            // Gửi mỗi file lên server
                                            axiosClient.post(`/uploadfile?subDirectory=${database}`, formData, config)
                                                .then(response => {
                                                    // Giả sử server trả về một URL của file
                                                    const fileUrl = LinkUpload(response?.data?.FilePath);

                                                    // Kiểm tra xem fileUrl có hợp lệ không, sau đó gọi callback để chèn vào editor
                                                    if (fileUrl) {
                                                        callback(fileUrl, { text: file.name });
                                                    } else {
                                                        console.error("Không nhận được URL từ server cho file:", file.name);
                                                    }
                                                })
                                                .catch(error => {
                                                    console.error("Lỗi khi tải lên file:", error);
                                                });
                                        });
                                    };
                                    input.click();
                                }
                            },


                        }}
                    />




                </div>

            </Form >


        )
    }
    const onDeleteArticles = (id) => {
        if (id !== 0) {
            swal({
                title: "Bạn có muốn xóa bài viết này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/Articles/DeleteArticles/${id}`, id, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataArticles(dataFilterArticle)
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const viewArticles = (record) => {
        setArticles(record)
        setValue(record.ArticleContent);
        setOpenModalViewArticles(true)
    }
    const menuArticles = (record) => (
        <Menu>
            <Menu.Item onClick={(e) => viewArticles(record)} key="2">
                <h3 >Xem</h3>
            </Menu.Item>
            <Menu.Item disabled={dataPermission.includes('UpdateArticles') ? false : true} onClick={(e) => showModalArticles(record)} key="0">
                <h3 style={{ color: dataPermission.includes('UpdateArticles') ? null : '#C0C0C0' }}>Cập nhật</h3>
            </Menu.Item>

            <Menu.Item disabled={dataPermission.includes('DeleteArticles') ? false : true} onClick={(e) => onDeleteArticles(record.ID)} key="3">
                <h3 style={{ color: dataPermission.includes('DeleteArticles') ? null : '#C0C0C0' }}>Xóa</h3>
            </Menu.Item>
        </Menu>
    );
    const columnArticles = [
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    ID
                </div>
            ),
            dataIndex: 'Name',
            width: 70,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <Row>
                            <Col span={24}>
                                {record.ID}
                            </Col>

                        </Row>

                    </div>
                );
            },
        },
        {
            title: "Bài viết",
            dataIndex: 'Title',
            width: 220,
            render: (text, record) => {
                const listTag = dataArticleTags
                    .filter(i => i.IDArticle === record.ID)
                    .map(r => r.IDTag).filter(Boolean);

                return (
                    <div>
                        <Row gutter={[0, 4]}>
                            <Col span={24}>
                                Tên bài viết: <b>{record.Title}</b>
                            </Col>
                            <Col span={24}>
                                Tag:&nbsp;
                                {listTag.map((r) => (
                                    <Tag color="gold" key={r}>
                                        {dataTags.find(i => i.ID === r)?.Name}
                                    </Tag>
                                ))}
                            </Col>
                        </Row>
                    </div>
                );
            },
        },
        {
            title: "Tác giả",
            dataIndex: 'IDAuthor',
            width: 200,
            render: (text, record) => (
                <Row gutter={[0, 4]}>
                    <Col span={24}>
                        Tác giả: <i>{dataAccount.find(i => i.ID === record.IDAuthor)?.FullName}</i>
                    </Col>
                    <Col span={24}>
                        Ngày viết: <b>{moment(record.PublishDate).format('DD-MM-YYYY HH:mm')}</b>
                    </Col>
                    <Col span={24}>
                        Danh mục: <b>{dataCategories.find(i => i.ID === record.IDCategory)?.Name}</b>
                    </Col>
                </Row>
            ),
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Slug
                </div>
            ),
            dataIndex: 'Phone',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left" }}>
                        {record.Slug}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Bản tóm tắt
                </div>
            ),
            dataIndex: 'Sumary',
            width: 200,
            render: (text, record) => {
                return (
                    <div
                        style={{
                            maxHeight: 200,
                            overflowY: 'auto',
                            paddingRight: 6,
                            lineHeight: '1.5em',
                            backgroundColor: '#fafafa',
                            borderRadius: 4,
                            border: '1px solid #f0f0f0'
                        }}
                    >
                        {text}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Hiển thị
                </div>
            ),
            dataIndex: 'Phone',
            width: 80,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.Status === 1 ? <CheckOutlined style={{ color: '#339933', fontSize: 18 }} /> : <CloseOutlined style={{ color: '#f50', fontSize: 18 }} />}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    Ảnh bìa
                </div>
            ),
            dataIndex: 'Phone',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <Image src={LinkUpload(record.ImageUrl)} width={100} style={{ objectFit: 'contain' }} />

                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 70,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <Dropdown
                            overlay={menuArticles(record)}
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <div style={{ textAlign: 'center' }}>
                                <Button type="text"><MenuOutlined style={{ color: '#2db7f5' }} /></Button>
                            </div>
                        </Dropdown>

                    </div>
                );
            },
        },
    ]
    const LoadDataAccount = () => {
        axiosClient.post('/Accounts/SubGetAccountsAll', user, {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataAccount(res.data);

            }
        })
    }
    const LoadDataArticleTags = () => {
        axiosClient.post('/ArticleTags/GetArticleTagsAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataArticleTags(res.data);

            }
        })
    }

    useEffect(() => {
        formFilterArticles.setFieldsValue({
            "IDCategory": 0,
            "Status": 0,
        })
        LoadDataArticleTags()
        LoadDataTags();
        LoadDataArticles(dataFilterArticle)
        LoadDataPermission()
        LoadDataCategories();
        LoadDataAccount()
    }, [])


    const handleCancelCategories = () => {
        setLoading(false);
        setOpenModalCategories(false);
    }
    const handleOkCategories = () => {
        setTimeout(() => {
            setLoading(false);
            setOpenModalCategories(false);
        }, 3000);
    }
    const handleCancelTags = () => {
        setLoading(false);
        setOpenModalTags(false);
    }
    const handleOkTags = () => {
        setTimeout(() => {
            setLoading(false);
            setOpenModalTags(false);
        }, 3000);
    }
    const handleCancelArticleTags = () => {
        setLoading(false);
        setOpenModalArticleTags(false);
    }
    const handleOkArticleTags = () => {
        setTimeout(() => {
            setLoading(false);
            setOpenModalArticleTags(false);
        }, 3000);
    }
    const handleCancelArticles = () => {
        setArticles({})
        setOpenModalViewArticles(false);
    }
    const handleOkArticles = () => {
        setTimeout(() => {
            setArticles({})
            setOpenModalViewArticles(false);
        }, 3000);
    }
    const isObjectEmpty = (object) => {
        return Object.keys(object).length === 0
    }

    const backStep = (step) => {
        switch (step) {
            case 0:
                return setOpenModalArticles(false);
            case 1:
                if (statusArticles === false) {
                    setStep(step - 1)
                    setOpenModalArticles(false)
                }
                else {

                    setStep(step - 1)
                }
        }

    }
    const onFinishFilterArticle = (values) => {
        const dataSearch = {
            "Title": values.Title || "",
            "IDCategory": values.IDCategory || "",
            "Status": values.Status || "",
            "FromDate_PublishDate": values.FromDate_PublishDate || "",
            "ToDate_PublishDate": values.ToDate_PublishDate || ""
        }
        setDataFilterArticle(dataSearch)
        LoadDataArticles(dataSearch)
    }
    const [formExcel] = Form.useForm();
    const [openModalExcel, setOpenModalExcel] = useState(false)
    const [dataExcel, setDataExcel] = useState([])
    const menuAdd = () => {
        return (
            <div>
                <Menu >
                    <Menu.Item disabled={dataPermission.includes('AddArticles') ? false : true} key={1} onClick={(e) => showModalArticles(0, e)}  >
                        Thêm mới
                    </Menu.Item>
                    <Menu.Item disabled={dataPermission.includes('AddArticles') ? false : true} onClick={(e) => setOpenModalExcel(true)} key="2" >
                        Thêm bằng Excel
                    </Menu.Item>

                </Menu>


            </div>
        )

    }

    const onFinishExcel = async (values) => {
        if (dataExcel.length === 0) return; // Nếu không có dữ liệu thì không làm gì cả

        try {
            // Gửi tất cả request để thêm bài viết
            const responses = await Promise.all(
                dataExcel.map(r =>
                    axiosClient.post(`/Articles/AddArticles`,
                        { ...r, IDCategory: values.IDCategory },
                        { headers: header }
                    )
                )
            );

            // Kiểm tra nếu responses có lỗi
            if (!responses || responses.length === 0) {
                throw new Error("Không có bài viết nào được thêm");
            }

            // Sau khi tất cả bài viết được thêm, gửi request để thêm tag cho từng bài viết
            await Promise.all(
                responses.map(res => {
                    if (!res.data || !res.data.ID || !res.data.Title) {
                        console.warn("Dữ liệu phản hồi từ API không hợp lệ:", res.data);
                        return null;
                    }
                    const articleID = res.data.ID;
                    const matchedArticle = dataExcel.find(i =>
                        i.Title && res.data.Title && String(i.Title).trim().toLowerCase() === String(res.data.Title).trim().toLowerCase()
                    );

                    // Nếu không tìm thấy bài viết phù hợp trong `dataExcel`, bỏ qua
                    if (!matchedArticle) {
                        console.warn(`Không tìm thấy bài viết phù hợp cho ID ${articleID}`);
                        return null;
                    }

                    const tagList = String(matchedArticle.Tag || "")
                        .split(",")
                        .map(tag => tag.trim())
                        .filter(tag => tag); // Loại bỏ tag rỗng

                    if (tagList.length === 0) {
                        console.warn(`Bài viết ${articleID} không có tag.`);
                        return null;
                    }

                    return axiosClient.post(`/Tags/AddTagList?IDArticle=${articleID}`,
                        tagList.map(tag => ({
                            "ID": 1,
                            "Name": tag,
                            "Slug": ""
                        })),
                        { headers: header }
                    );
                }).filter(Boolean) // Loại bỏ các `null` tránh lỗi Promise.all
            );

            // Sau khi tất cả request hoàn tất, tải lại dữ liệu một lần duy nhất
            await LoadDataArticles(dataFilterArticle);
            await LoadDataArticleTags(); // Load lại danh sách tags

            // Hiển thị thông báo thành công
            swal('Thành công!', {
                icon: 'success',
                timer: 3000
            });

            // Reset dữ liệu Excel
            setDataExcel([]);
            setOpenModalExcel(false)
        } catch (error) {
            console.error("Lỗi trong quá trình xử lý:", error);
            swal('Lỗi!', 'Có lỗi xảy ra khi xử lý, vui lòng thử lại.', 'error');
        }
    };

    const handleMenuClickUploadExcel = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    function excelDateToJSDate(excelDate) {
        // Excel sử dụng 1/1/1900 làm ngày bắt đầu, nhưng ngày này có giá trị là 1 trong Excel.
        const startDate = new Date(Date.UTC(1900, 0, 1)); // 1/1/1900 theo UTC
        const jsDate = new Date(startDate.getTime() + (excelDate - 2) * 24 * 60 * 60 * 1000); // Trừ đi 2 để xử lý năm nhuận trong Excel

        return jsDate;
    }
    const transformData = (array) => {
        return array.map((item, index) => ({
            ID: 1,
            Title: item[0] || "",
            Sumary: item[1] || "",
            PublishDate: excelDateToJSDate(item[2]) || "",
            Tag: item[3] || "",
            ArticleContent: item[4] || "",
            ImageUrl: item[5] || "",

            Status: 1,
            ArticleView: 0,
            IDAuthor: Number(IDAccount),
            Slug: ''
        }));
    };
    const handleFileUploadExcel = (event) => {
        const file = event.target.files[0];

        if (!file) {
            console.error("Không có file nào được chọn.");
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const binaryStr = e.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });

                // Đọc sheet đầu tiên
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];

                // Chuyển đổi dữ liệu thành JSON
                const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
                const data = transformData(jsonData.filter((item, index) => index !== 0))
                setDataExcel(data)
            } catch (error) {
                console.error("Lỗi khi đọc file Excel:", error);
            }
        };

        reader.readAsBinaryString(file); // Đặt nó ở đây thay vì bên trong onload
    };

    const handleDownloadExcel = () => {
        const fileUrl = `${process.env.PUBLIC_URL}/Excel-Add-Article.xlsx`; // Đường dẫn đến file trong thư mục public
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Excel-Add-Article.xlsx"; // Tên file khi tải về
        link.click();
    };
    const renderExcel = () => {
        return (
            <Form
                id="form-Excel"
                form={formExcel}
                onFinish={onFinishExcel}
                name="basic"
                labelCol={{
                    span: 24,
                    style: { fontWeight: 'bold' },
                }}
                wrapperCol={{
                    span: 24,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >

                <Card size="small" bordered={false} style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '100%' }}>
                    <Form.Item hidden name={'ID'} >
                        <Input />
                    </Form.Item>
                    <Form.Item rules={[
                        {
                            required: true,
                            message: "Chọn danh mục để tiếp tục",
                        },
                    ]} label='Danh mục' name={'IDCategory'}>
                        <Select filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                        } showSearch>
                            {dataCategories.map(r => (
                                <Option value={r.ID}>{r.Name}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <ButtonGroup>
                        <Button style={{ backgroundColor: "#26A69A", color: "white" }} onClick={handleMenuClickUploadExcel}>Upload từ file excel</Button>
                        <Button onClick={handleDownloadExcel} style={{ color: '#1890FF', fontStyle: 'italic' }} type="text">File mẫu</Button>
                    </ButtonGroup>


                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileUploadExcel}
                    />
                </Card>
            </Form>
        )
    }

    return (
        <div>
            <Card size="small">
                <Tabs type="card"
                    tabBarGutter={10}
                    tabPosition="top" // Hiển thị tabs theo chiều ngang
                    tabBarStyle={{ backgroundColor: "#D6E4FF", borderRadius: "8px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)" }}
                    moreIcon={null} >
                    <TabPane tab="Bài viết" key="1">
                        {openModalArticles ? <div >
                            <Card
                                title={
                                    <Steps current={step} style={{ marginBottom: 20 }}>
                                        <Step
                                            title={statusArticles ? 'Cập nhật bài viết' : 'Thêm mới bài viết'}
                                            description=""
                                            style={{ fontSize: 14, fontWeight: 'bold' }}
                                        />
                                        <Step
                                            title="Nội dung"
                                            style={{ fontSize: 14, fontWeight: 'bold' }}
                                        />
                                    </Steps>
                                }
                                style={{ borderRadius: '10px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)' }}
                            >
                                {step === 0 && openModalArticles ? renderArticles(0) : null}
                                {step === 1 && openModalArticles ? renderArticles(1) : null}

                                <Divider style={{ margin: '16px 0' }} />

                                <div style={{ textAlign: 'right' }}>
                                    <Button.Group>
                                        <Button

                                            onClick={(e) => setOpenModalArticles(false)}
                                            style={{
                                                backgroundColor: '#f5f5f5',
                                                borderColor: '#d9d9d9',
                                                color: '#1890ff',
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Thoát
                                        </Button>

                                        <Button
                                            hidden={step === 0}
                                            onClick={(e) => setStep((prevStep) => prevStep - 1)}
                                            style={{
                                                backgroundColor: '#f5f5f5',
                                                borderColor: '#d9d9d9',
                                                color: '#1890ff',
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Quay lại
                                        </Button>

                                        <Button
                                            form="form-Articles"
                                            type="primary"
                                            htmlType="submit"
                                            style={{
                                                backgroundColor: '#33cc99',
                                                borderColor: '#28a745',
                                                color: 'white',
                                                fontSize: 14,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {step === 1 ? 'Lưu' : 'Tiếp'}
                                        </Button>
                                    </Button.Group>
                                </div>
                            </Card>
                        </div>
                            : <Row gutter={16}>

                                <Col span={24}>
                                    <Form onFinish={onFinishFilterArticle} id="form-filter-Articles" form={formFilterArticles}>
                                        <Row gutter={[8, 8]}>
                                            <Col xs={24} xl={8} span={8}>
                                                <Form.Item label='Tên bài viết' name={'Title'}>
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} xl={8} span={8}>
                                                <Form.Item label='Danh mục' name={'IDCategory'}>
                                                    <Select filterOption={(input, option) =>
                                                        option.children.toLowerCase().includes(input.toLowerCase())
                                                    } showSearch>
                                                        <Option value={0}>Tất cả</Option>
                                                        {dataCategories.map(r => (
                                                            <Option value={r.ID}>{r.Name}</Option>
                                                        ))}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} xl={8} span={8}>
                                                <Form.Item label='Trạng thái' name={'Status'}>
                                                    <Select>
                                                        <Option value={0}>Tất cả</Option>
                                                        <Option value={1}>Hiển thị</Option>
                                                        <Option value={2}>Ngừng hiển thị</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} xl={8} span={8}>
                                                <Form.Item label='Từ ngày' name={'FromDate_JoinDate'}>
                                                    <DatePicker style={{ width: '100%' }} placeholder="Chọn ngày" format={'DD-MM-YYYY'} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} xl={8} span={8}>
                                                <Form.Item label='Đến ngày' name={'ToDate_JoinDate'}>
                                                    <DatePicker style={{ width: '100%' }} placeholder="Chọn ngày" format={'DD-MM-YYYY'} />
                                                </Form.Item>
                                            </Col>
                                            <Col xl={24} xs={24} span={12}>
                                                <ButtonGroup>

                                                    <Button form="form-filter-Articles" htmlType="submit" type="primary" style={{ width: "100%", backgroundColor: "#26A69A" }}>
                                                        <p>Lọc</p>
                                                    </Button>
                                                    &ensp;
                                                    <Dropdown
                                                        overlayStyle={{ width: 200 }}
                                                        overlay={menuAdd()}
                                                        trigger={["click"]}
                                                        placement="bottomRight"
                                                    >
                                                        <Button htmlType="submit" type="primary" style={{ width: "100%", backgroundColor: "#26A69A" }}>
                                                            <p>Thêm</p>
                                                        </Button>
                                                    </Dropdown>
                                                </ButtonGroup>

                                            </Col>
                                        </Row>

                                    </Form>
                                </Col>
                                <Col span={24}>
                                    <br />
                                </Col>
                                <Col xs={24} xl={24} span={24}>
                                    <Table rowClassName={(record, index) => {
                                        return index % 2 === 0 ? "gray-color" : "";
                                    }} scroll={{ x: 1000 }} size="middle" dataSource={dataArticles} pagination={{ pageSize: 10 }} sticky columns={columnArticles} />
                                </Col>
                            </Row>}

                    </TabPane>
                    <TabPane tab="Danh mục" key="2">
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form id="form-filter-Categories" form={formFilterCategories}>
                                    <Row gutter={[8, 8]}>
                                        <Col xs={24} xl={24} span={4}>
                                            <Button hidden={dataPermission.includes('AddCategories') ? false : true} key={1} onClick={(e) => showModalCategories(0, e)} style={{ backgroundColor: "#26A69A", color: 'white' }} >
                                                <p>Thêm mới</p>
                                            </Button>

                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                            <Col xs={24} xl={24} span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} scroll={{ x: 1000 }} size="middle" dataSource={dataCategories} pagination={{ pageSize: 10 }} sticky columns={columnCategories} />
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tab="Quản lý Tags" key="3">
                        <Row gutter={16}>
                            <Col span={24}>

                                <Row gutter={[8, 8]}>
                                    <Col xs={24} xl={24} span={4}>
                                        <Button hidden={dataPermission.includes('AddTags') ? false : true} key={1} onClick={(e) => showModalTags(0)} style={{ backgroundColor: "#26A69A", color: 'white' }} >
                                            <p>Thêm mới</p>
                                        </Button>

                                    </Col>
                                </Row>

                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                            <Col xs={24} xl={24} span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} scroll={{ x: 1000 }} size="middle" dataSource={dataTags} pagination={{ pageSize: 10 }} sticky columns={columnTags} />
                            </Col>
                        </Row>
                    </TabPane>

                </Tabs>
            </Card>

            <Modal
                width={600}
                headStyle={{ backgroundColor: '#EEEEEE' }}
                bodyStyle={{
                    backgroundColor: '#EEEEEE',
                }}
                onOk={handleOkCategories}
                onCancel={handleCancelCategories}
                open={openModalCategories}
                title={
                    <span>
                        {statusCategories === false ? 'Thêm mới Danh mục' : 'Cập nhật Danh mục'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelCategories} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Categories" type="primary" htmlType="submit" loading={loading}>
                        Lưu
                    </Button>,
                ]}
            >
                {loading ? (
                    <>
                        <Skeleton loading={loading} active />
                    </>
                ) : (
                    <>{renderCategories()}</>
                )}
            </Modal>
            <Modal
                width={600}
                headStyle={{ backgroundColor: '#EEEEEE' }}
                bodyStyle={{
                    backgroundColor: '#EEEEEE',
                }}
                onOk={handleOkTags}
                onCancel={handleCancelTags}
                open={openModalTags}
                title={
                    <span>
                        {statusTags === false ? 'Thêm mới tag' : 'Cập nhật tag'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelTags} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Tags" type="primary" htmlType="submit" loading={loading}>
                        Lưu
                    </Button>,
                ]}
            >
                {loading ? (
                    <>
                        <Skeleton loading={loading} active />
                    </>
                ) : (
                    <>{renderTags()}</>
                )}
            </Modal>
            <Modal
                width={600}
                headStyle={{ backgroundColor: '#EEEEEE' }}
                bodyStyle={{
                    backgroundColor: '#EEEEEE',
                }}
                onOk={handleOkArticleTags}
                onCancel={handleCancelArticleTags}
                open={openModalArticleTags}
                title={
                    <span>
                        {statusArticleTags === false ? 'Thêm mới tag bài viết' : 'Cập nhật tag bài viết'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelArticleTags} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-ArticleTags" type="primary" htmlType="submit" loading={loading}>
                        Lưu
                    </Button>,
                ]}
            >
                {loading ? (
                    <>
                        <Skeleton loading={loading} active />
                    </>
                ) : (
                    <>{renderArticleTags()}</>
                )}
            </Modal>
            <Modal
                width={1000}
                headStyle={{ backgroundColor: '#EEEEEE' }}
                bodyStyle={{
                    backgroundColor: '#EEEEEE',
                }}
                onOk={handleOkArticles}
                onCancel={handleCancelArticles}
                open={openModalViewArticles}
                title={
                    null
                }
                closable={null}
                closeIcon={null}
                footer={[
                    <Button onClick={handleCancelArticles} key="back" >
                        Hủy
                    </Button>,

                ]}
            >
                <Row>
                    {isObjectEmpty(articles) === false ? <Col span={24}>
                        <Row>
                            <Col style={{ fontSize: 27, fontWeight: 700, color: 'red' }} span={24}>
                                {articles.Title}
                            </Col>
                            <Col style={{ fontSize: 18, fontWeight: 400, color: '#7A6666' }} span={24}>
                                <FileTextOutlined style={{ color: '#FF8411', fontSize: 18 }} /> {moment(articles.PublishDate).format('DD/MM/YYYY')}<Divider type="vertical" /><UserOutlined style={{ color: '#FF8411', fontSize: 18 }} /> {dataAccount.filter(i => i.ID === articles.IDAuthor).map(r => r.FullName)}<Divider type="vertical" /><EyeOutlined style={{ color: '#FF8411', fontSize: 18 }} /> {articles.ArticleView}
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                        </Row>
                    </Col> : null}

                    <Col span={24}>
                        <div dangerouslySetInnerHTML={{
                            __html: value
                        }}></div>
                    </Col>
                </Row>
            </Modal>
            <Modal
                width={800}
                headStyle={{ backgroundColor: '#EEEEEE' }}
                bodyStyle={{
                    backgroundColor: '#EEEEEE',
                }}
                onOk={(e) => setOpenModalExcel(false)}
                onCancel={(e) => setOpenModalExcel(false)}
                open={openModalExcel}
                title={
                    <span>
                        Thêm mới bằng Excel
                    </span>
                }
                footer={[
                    <Button onClick={(e) => setOpenModalExcel(false)} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Excel" type="primary" htmlType="submit" loading={loading}>
                        Lưu
                    </Button>,
                ]}
            >

                <>{renderExcel()}</>

            </Modal>
        </div >
    )

}
export default Content;